import publisherAPIInstance from "./publisherApiInstance";

const publishingCloudAPIs = {
  getCloudPreSignedURL: ({ payload }) => publisherAPIInstance.post(`/api/v1/cloud.getPresignedUrl`, payload),
  getDownloadVideo: ({ payload }) => publisherAPIInstance.post(`/api/v1/cloud.downloadVideo`, payload),
  publicDownloadVideo: ({ payload }) => publisherAPIInstance.post(`/api/v1/cloud.publicDownloadVideo`, payload),
  bulkCloudPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/cloud.bulkPublish`, payload),
  getDownloadStatus: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/downloadHistory.getDownloadConsumption`, payload),
  getDownloadStreamLimits: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/downloadHistory.getAllStreamLimit`, payload),
  updateDownloadHistoryStream: ({ payload }) => publisherAPIInstance.post(`/api/v1/downloadHistory.update`, payload),
  getDownloadBulkVideo: ({ payload }) => publisherAPIInstance.post(`/api/v1/cloud.downloadBulkVideo`, payload),
};
export default publishingCloudAPIs;
